import { CMSApiBase, CMSGroupParams, CMSImageBase, createCmsUrl } from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

export interface ReferralHowToParticipateCard {
  title: string;
  description: string;
  id: number;
  cardImage: CMSImageBase;
}

export interface ReferralDataItem {
  question: string;
  answer: string;
}

export interface ReferralHowToCard {
  title: string;
  description: string;
}

export interface ReferralHowToParticipate extends CMSGroupParams {
  cards: ReferralHowToParticipateCard[];
  content: ReferralHowToCard[];
}

export interface RefferalProgramApi extends CMSApiBase {
  title: string;
  description: string;
  bonusTitle: string;
  bonusSubtitle: string;
  howToTitle: string;
  enable: boolean;
  topBg: CMSImageBase;
  leftImg: CMSImageBase;
  rightImg: CMSImageBase;
  lupImg: CMSImageBase;
  onePlusImg: CMSImageBase;
  mobImg: CMSImageBase;
  referralBonus: string;
  howToParticipate: ReferralHowToParticipate;
  questions: ReferralDataItem[];
  cards: ReferralHowToParticipateCard[];
}

export const getReferralProgramUrl = (lang: string) =>
  createCmsUrl({
    path: 'referral-program',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const fetchReferralProgram = async (lang: string) => {
  const response = await fetcherCMS<RefferalProgramApi>(
    getReferralProgramUrl(lang)
  );
  return { data: response };
};
